module.exports = "<div class=\"header\">\n  <span>{{ title }}</span> <br>\n  <span class=\"version\">Version: {{ version }}</span>\n</div>\n"